import * as React from 'react';
import { AbstractSharingLink } from './AbstractSharingLink';

export class DirectLink extends AbstractSharingLink {
    public render() {
        const model = this.props.model;
        const uri = this.buildSharingUri(model);
        const title = this.context.i18n.translate('Direktlink teilen');

        return <div className="jc-share-link -direct-link">
            <a href={uri} target="_blank" rel="noopener noreferrer" title={title}>
                <i className="far fa-external-link"/>
            </a>
        </div>;
    }
}
